import script from "./sample-list.vue?vue&type=script&setup=true&lang=js"
export * from "./sample-list.vue?vue&type=script&setup=true&lang=js"

import "./sample-list.vue?vue&type=style&index=0&id=da19168a&lang=scss&scoped=true"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da19168a"]])

export default __exports__